import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import UerpPageHero from "./components/UerpPageHero";
import UerpIntroSection from "./components/UerpIntroSection";
import UerpWhatWeProvideSection from "./components/UerpWhatWeProvideSection";
import UerpAdvantagesSection from "./components/UerpAdvantagesSection";
import UerpHowItWorksSection from "./components/UerpHowItWorksSection";
import UerpModulesSection from "./components/UerpModulesSection";
import WdevTestimonials from "../WebDevelopmentPage/components/WdevTestimonials";
import UerpCtaBanner from "./components/UerpCtaBanner";
import "../WebDevelopmentPage/web-development.css";
import "../HospitalManagementPage/hospital-management.css";
import "./university-erp.css";

const UniversityErpPage: React.FC = () => {
  useEffect(() => {
    document.title =
      "University Institution College ERP | WebTech Software Solutions Bangalore";
    const description =
      "WebTech builds University, Institution & College ERP software in Bangalore — student portal, faculty, admin, examinations, finance, library, and hostel modules.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);

  return (
    <Fragment>
      <div className="wdev-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <UerpPageHero />
            <UerpIntroSection />
            <UerpWhatWeProvideSection />
            <UerpAdvantagesSection />
            <UerpHowItWorksSection />
            <UerpModulesSection />
            <WdevTestimonials />
            <UerpCtaBanner />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default UniversityErpPage;
